// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fizy-logo/fizy-logo.less
// module id = 263
// module chunks = 0